import { Injectable } from '@angular/core';
import { Pagination } from 'src/app/domain/pagination';
import { HttpParams, HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Piece } from 'src/app/domain/piece';
import { PieceDTO } from 'src/app/domain/dto/piece.dto';

@Injectable({
  providedIn: 'root'
})
export class PieceService {

  url: string = `${environment.BASE_URL}/pieces`;
  httpHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Cache-Control': 'no-cache' });

  constructor(private http: HttpClient) { }

  getPieces(piece: Piece, pagination: Pagination) {

    const params = {
      page: `${pagination.page ?? 1}`,
      per_page: `${pagination.per_page ?? 10}`,
      name: `${piece.name ?? ""}`,
      active: `${piece.active ?? ''}`
    };

    return this.http.get(this.url,
      { responseType: "json", params: params });

  }

  getPiecesSelect() {
    return this.http.get<Array<Piece>>(`${this.url}/all-actives`,
      { responseType: "json" });
  }

  getPiece(id: number) {
    return this.http.get<Piece>(`${this.url}/${id}`,
      { responseType: "json" });

  }
  save(piece: Piece) {
    let dto = new PieceDTO(piece);

    return this.http.post(`${this.url}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  update(piece: Piece) {
    let dto = new PieceDTO(piece);
    console.log(JSON.stringify(dto));
    return this.http.put(`${this.url}/${piece.id}`, JSON.stringify(dto), {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  delete(id: number) {
    return this.http.delete(`${this.url}/${id}`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  active(id: number) {
    return this.http.put(`${this.url}/${id}/active`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
  deactive(id: number) {
    return this.http.put(`${this.url}/${id}/deactivate`, {
      headers: this.httpHeaders,
      observe: 'response',
    });
  }
}
